<style lang="less">
@import "./login.less";
</style>

<template>
    <div class="login">
        <div class="login-con">
            <Card :bordered="false"
                icon="log-in"
                title="种苗网 欢迎登录"
                style="background-color: white;">
                <div class="form-con">
                    <div style="width:276px; float: left; text-align: center;">
                        <img key="max-logo"
                            :src="maxLogo"
                            style="width:276px; height: 89px;">
                        <span style="text-align: center; font-size: 24px; color: rgb(0, 153, 0);">缤纷种苗网上销售平台</span>
                    </div>
                    <div style="width:250px; float: right">
                        <login-form :loading="submitBtnLoading"
                            @on-success-valid="handleSubmit" />
                    </div>
                </div>
            </Card>
        </div>

    </div>
</template>

<script>
import LoginForm from './login-form';
import { mapActions } from 'vuex';
import maxLogo from '@/assets/images/brighten_seed_logo_new.png';
import { saveUserInfo } from '@/utils/localStorage';

export default {
    components: {
        LoginForm
    },
    data() {
        return {
            maxLogo,
            submitBtnLoading: false
        };
    },
    methods: {
        ...mapActions([
            'handleLogin',
            'getUserInfo'
        ]),
        handleSubmit({ userName, password }) {
            this.submitBtnLoading = true;
            this.handleLogin({ userName, password }).then(res => {
                this.submitBtnLoading = false;
                if (res.code === 0) {
                    if (res.data.userInfo.userType === 'E' || res.data.userInfo.userType === 'F') {
                        this.$Modal.error({ title: '用户类型有误，请联系系统管理员。' });
                    }
                    else {
                        this.submitBtnLoading = true;
                        this.getUserInfo().then(() => {
                            let userInfo = res.data.userInfo;
                            saveUserInfo(userInfo);
                            this.submitBtnLoading = false;
                            this.$router.push({
                                path: '/home'
                            });
                        });
                    }
                }
            });
        }
    }
};
</script>

<style>
</style>
